import { getOrderItemsByItemId } from './get-order-items-by-item-id';
/**
 * Gets the first order item with the matching itemId and optional priceRestriction.
 */
export const getOrderItemByItemId = (itemId, priceRestriction) => {
    return getOrderItemsByItemId(itemId, priceRestriction)[0];
};
